module.exports = __webpack_public_path__ + "static/media/traffic-signal.6daf806f.svg";